const Footer = () => {
  return (
    <footer className="footer">
        &copy; 부산맛집 (Busan Restaurant)
    </footer>
  )
}

export default Footer;